import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-seller-agreement',
  templateUrl: './seller-agreement.component.html',
  styleUrls: ['./seller-agreement.component.scss']
})
export class SellerAgreementComponent implements OnInit {
  @Input() isShowSellerArtist: boolean = false;
  isAcceptTermCondition: any = '';
  constructor(public commonService: CommonService,
    private authService:AuthService,
    private activateRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activateRoute.data.subscribe( (data: any) => {
      this.commonService.setTitleService(data['title'])
    });
  }

  closeByDeviceType() {
    this.commonService.closePopUp();
  }

  isCallApiSellerAccept() {
    this.authService.isAcceptTermConditionSeller().subscribe( res => {
      this.closeAndUpdate();
    }, (err) => {
      if(err?.error?.message === 'Terms already accepted') {
        this.closeAndUpdate();
      } else {
        // this.popUpService.getErrorMessage(err);
      }
    });
  }

  closeAndUpdate() {
    // this.storageService.updateSellerAgreementCheckCheck();
    this.closeByDeviceType();
  }

}
